export const FETCH_USERS_START = "FETCH_USERS_START";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";
export const MEDIATOR_REQUEST_START = "MEDIATOR_REQUEST_START";
export const MEDIATOR_REQUEST_SUCCESS = "MEDIATOR_REQUEST_SUCCESS";
export const MEDIATOR_REQUEST_FAILURE = "MEDIATOR_REQUEST_FAILURE";
export const FETCH_MEDIATORS_START = "FETCH_MEDIATORS_START";
export const FETCH_MEDIATORS_SUCCESS = "FETCH_MEDIATORS_SUCCESS";
export const FETCH_MEDIATORS_FAILURE = "FETCH_MEDIATORS_FAILURE";
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const CHECKING_USER = "CHECKING_USER";
export const USER = "USER";
export const NO_USER = "NO_USER";
export const GOT_USER_INFO = "GOT_USER_INFO";
export const SIGN_OUT = "SIGN_OUT";
export const FETCH_USER_START = "FETCH_USER_START";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const UPDATE_USER_START = "UPDATE_USER_START";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
